<!-- =========================================================================================
  File Name: uploads/VideoUpload.vue
  Description: Form to edit a youtube link
========================================================================================== -->

<template>
  <div>
    <label for="" class="vs-input--label">Volume</label>
    <vs-slider ticks step="1" class="mb-5" text-fixed="%" :step-decimals="true" v-model="volume" />
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    initialPlacement: {},
    hobject: {},
    initialAnchor: {},
  },
  data() {
    return {
      volume: 85,
    }
  },
  watch: {
    volume: function(updatedValue) {
      try {
        var abilities = JSON.parse(this.hobject.abilities)
        abilities.audio.volume = updatedValue / 100
        this.hobject.abilities = JSON.stringify(abilities)
      } catch (e) {
        console.error(e)
      }
    },
  },
  created() {
    // Get Volume
    try {
      var abilities = JSON.parse(this.hobject.abilities)
      console.log(Number(abilities.audio.volume))
      if (Number(abilities.audio.volume) === abilities.audio.volume && abilities.audio.volume % 1 !== 0)
        this.volume = abilities.audio.volume * 100
    } catch (e) {
      console.error(e)
    }
  },
  computed: {},
  methods: {},

  components: {},
}
</script>

<style lang="scss">
.margin-top {
  margin-top: 25px;
}

.con-vs-alert .con-vs-alert-primary {
  height: auto !important;
}
</style>
